export default {
 BT_HDP: "แฮนดีแคพ | HDP",
  BT_OU: "สูงกว่า ต่ำกว่า | O/U",
  BT_ML: "มันนี่ไลน์",
  BT_1X2: "1X2",
  BT_1X2HDP: "แฮนดิแคป 3 ทาง",
  BT_CS: "คะแนนที่ถูกต้อง",
  BT_OE: "คู่ คี่  | คี่/คู่",
  BT_DC: "สองโอกาส",
  BT_HTFT: "ครึ่งเวลา / เต็มเวลา",
  BT_FGLG: "โกลแรก / สุดท้าย",
  BT_TG: "จำนวนโกลทั้งหม",
  BT_OR: "ผลชนะเลิศ",
  BT_ORZ: "ผลชนะเลิศ",

  BT_ANB: "ไม่มีการวางเดิมพันทีมเยือน",
  BT_BS: "ทั้งสองทีม/หนึ่งทีม/ไม่มีทีมใดที่ทำคะแนนได้",
  BT_CL: "ไม่เสียประตู",
  BT_DNB: "เสมอไม่เดิมพัน",
  BT_HNB: "ไม่มีการวางเดิมพันทีมเหย้า",
  BT_TWTN: "ชนะโดยไม่เสียประตู",

  BT_HDPF: "เต็มเวลา แฮนดีแคพ | เต็มเวลา. HDP",
  BT_OUF: "เต็มเวลา สูงกว่า ต่ำกว่า | เต็มเวลา O/U",
  BT_MLF: "เต็มเวลา มันนี่ไลน์",
  BT_1X2F: "เต็มเวลา 1X2",
  BT_1X2HDPF: "เต็มเวลา แฮนดิแคป 3 ทาง",
  BT_CSF: "เต็มเวลา คะแนนที่ถูกต้อง",
  BT_OEF: "เต็มเวลา คี่ คู่",
  BT_DCF: "เต็มเวลา สองโอกาส",
  BT_FGLGF: "เต็มเวลา โกลแรก / สุดท้าย",
  BT_TGF: "เต็มเวลา จำนวนโกลทั้งหม",

  BT_HDPH: "ครึ่งเวลา แฮนดีแคพ | ครึ่งเวลา. HDP",
  BT_OUH: "ครึ่งเวลา สูงกว่า ต่ำกว่า | ครึ่งเวลา O/U",
  BT_MLH: "ครึ่งเวลา มันนี่ไลน์",
  BT_1X2H: "ครึ่งเวลา 1X2",
  BT_1X2HDPH: "ครึ่งเวลา แฮนดิแคป 3 ทาง",
  BT_CSH: "ครึ่งเวลา คะแนนที่ถูกต้อง",
  BT_OEH: "ครึ่งเวลา คี่ คู่",
  BT_DCH: "ครึ่งเวลา สองโอกาส",
  BT_FGLGH: "ครึ่งเวลา โกลแรก / สุดท้าย",
  BT_TGH: "ครึ่งเวลา จำนวนโกลทั้งหม",

  BT_HDPOU: "แฮนดิแคป & มากกว่า/น้อยกว่า",
  BT_PARLAY: "มิกซ์ พาร์เลย์",
  BT_FT: "เต็มเวลา. ",
  BT_1H: "ครึ่งแรก. ",
  BT_2H: "ครึ่งหลัง. ",

  BT_FG: "ประตูแรก",
  BT_LG: "ประตูสุดท้าย",
  BT_HFG: "HFG",
  BT_AFG: "AFG",
  BT_HLG: "HLG",
  BT_ALG: "ALG",
  BT_NG: "ไม่มีประตู",
  BT_HY: "เจ้าบ้าน ไม่เสียประ",
  BT_HN: "เจ้าบ้าน เสียประตู",
  BT_AY: "ทีมเยือน ใช",
  BT_AN: "ทีมเยือน เสียประตู",
  BT_H: "เจ้าบ้าน",
  BT_A: "ทีมเยือน",
  BT_D: "เสมอกัน",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",

  BT_Y: "ใช่",
  BT_N: "ไม่มี",

  BT_LIVE: "สดๆ",
  BT_HT: "ครึ่งแรก",
  BT_DELAYED: "DELAY",
  BT_PEN: "PEN",

  BT_FT1: "เต็มเวลา.1",
  BT_FT2: "เต็มเวลา.2",
  BT_FTX: "เต็มเวลา.X",
  BT_HT1: "ครึ่งเวลา.1",
  BT_HT2: "ครึ่งเวลา.2",
  BT_HTX: "ครึ่งเวลา.X",

  BT_BOTH: "ทั้งคู่",
  BT_ONE: "หนึ่ง",
  
  LOT_BS: "ใหญ่/เล็ก",
  LOT_BIG: "ใหญ่",
  LOT_SMALL: "เล็ก",
  LOT_OE: "คี่/คู่",
  LOT_ODD: "คี่",
  LOT_EVEN: "คู่",
  LOT_OU: "าสูง/ต่ำ",
  LOT_OVER: "าสูง",
  LOT_UNDER: "ต่ำ",

  BT_ALL: "@:ui.bet_list",

  D_1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  BT_HDPMMO: "HDPMMO",
  BT_OUMMO: "OUMMO",

  BT_OEHM: "บ้าน คี่/คู่ | บ้าน O/E",
  BT_OEHMH: "FH. บ้าน คี่/คู่ | FH. บ้าน O/E",
  BT_OEAW: "ทีมเยือน คี่/คู่ | ทีมเยือน O/E",
  BT_OEAWH: "FH. ทีมเยือน คี่/คู่ | FH. ทีมเยือน O/E",

  BS_OEHM: "FT. บ้าน คี่/คู่ | FT. บ้าน O/E",
  BS_OEHMH: "FH. บ้าน คี่/คู่ | FH. บ้าน O/E",
  BS_OEAW: "FT. ทีมเยือน คี่/คู่ | FT. ทีมเยือน O/E",
  BS_OEAWH: "FH. ทีมเยือน คี่/คู่ | FH. ทีมเยือน O/E",

  MB_OVER: "สูงกว่า (4,5,6)",
  MB_UNDER: "ต่ำกว่า (1,2,3)",
  MB_ODD: "คี่ (1,3,5)",
  MB_EVEN: "คู่ (2,4,6)",

  BS_1X2OU: "1X2 + O/U",
  BT_1X2OU: "1X2 + O/U",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "Double Chance + O/U",
  BT_DCOU: "Double Chance + O/U",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "O/U + O/E",
  BT_OUOE: "O/U + O/E",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "HT/FT + O/E",
  BT_HTFTOE: "HT/FT + O/E",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "Winning Margin",
  BT_WM: "Winning Margin",
  BK_H1: "บ้าน 1",
  BK_H2: "บ้าน 2",
  BK_H3Up: "บ้าน 3+",
  BK_A1: "ทีมเยือน 1",
  BK_A2: "ทีมเยือน 2",
  BK_A3Up: "ทีมเยือน 3+",
  BK_D: "เสมอ (ยกเว้น 0-0)",
  BK_NG: "ไม่มีประตู",

  BS_ETG: "Exact Total Goal",
  BT_ETG: "Exact Total Goal",
  BS_EHTG: "Exact Home Total Goal",
  BT_EHTG: "Exact Home Total Goal",
  BS_EATG: "Exact Away Total Goal",
  BT_EATG: "Exact Away Total Goal",
  BS_ETGH: "FH. Exact Total Goal",
  BT_ETGH: "FH. Exact Total Goal",
  BS_EHTGH: "FH. Exact Home Total Goal",
  BT_EHTGH: "FH. Exact Home Total Goal",
  BS_EATGH: "FH. Exact Away Total Goal",
  BT_EATGH: "FH. Exact Away Total Goal",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "สกอร์ HT/FT",
  BS_CSHTFT: "สกอร์ HT/FT",
  BT_ETGHTFT: "ประตูรวม HT/FT",
  BS_ETGHTFT: "ประตูรวม HT/FT",

  MBR_SINGLE: "Single",
  MBR_TRIPS: "Trips",
  MBR_PAIR: "Pair",

};